import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import Container from '@material-ui/core/Container';

import App from './app';
import { AppContextProvider } from './contexts/app-context';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <AppContextProvider>
    <BrowserRouter forceRefresh={true}  >
      {
        isMobile ?
          <Container maxWidth="xl" component="div" style={{ margin: 'auto', padding: '1px', border: 0, width: "100vw", maxWidth: "calc(100vw - 20px)" }}>
            <App />
          </Container>
          :
          <Container maxWidth="xl" component="div" style={{ margin: 'auto', padding: '1px', border: 0, width: "100vw", maxWidth: "calc(100vw - 40px)" }}>
            <App />
          </Container>
      }

    </BrowserRouter>
  </AppContextProvider>
  ,
  document.getElementById('root')
);


serviceWorker.unregister();